/* ===========================================================
   hide-soldout-b4b-cards.js
   -----------------------------------------------------------
   Removes B4B (Variants Products app) variant cards whose
   button is "Sold out" / disabled.

   Why this is needed: B4B renders card skeletons in the
   initial HTML, then its own JS populates the button state
   ("ADD TO CART" vs "Sold out") AFTER page load. So we sweep
   multiple times and also watch for any subtree changes.

   Target DOM (updated 2026-06-01 for the .mkp-card unification —
   the old .gpn-card / .gpn-btn classes were renamed by the S5
   card consolidation, which silently orphaned this script):
     <article class="mkp-card">
       <div class="mkp-card__body">
         <button class="mkp-card__atc" disabled>Sold out</button>
       </div>
     </article>
   The legacy .gpn-card / .gpn-btn selectors are kept as a
   fallback in case any un-migrated B4B cards still render.

   Reverse: delete this file and its <script> include in
   layout/theme.liquid.
   =========================================================== */
(function () {
  'use strict';

  function sweep() {
    // .mkp-card is the unified card system; .gpn-card is the legacy fallback.
    var cards = document.querySelectorAll('article.mkp-card, article.gpn-card');
    var removed = 0;
    cards.forEach(function (card) {
      var btn = card.querySelector('button.mkp-card__atc, button.gpn-btn');
      if (!btn) return;
      // Only treat as sold out if the button text explicitly says so. The
      // button is also briefly `disabled` during the "Adding…" / "Added ✓"
      // cart-add transition (see the ATC handler in assets/product-card.js);
      // we must NOT remove the card during that window.
      var soldOut = /sold\s*out/i.test(btn.textContent || '');
      if (soldOut) {
        card.remove();
        removed++;
      }
    });
    return removed;
  }

  // Initial sweep on DOM ready.
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }
  onReady(sweep);

  // Window load — covers cards that B4B populated after DOM ready but before "load".
  window.addEventListener('load', sweep);

  // Polling fallback — sweep every 250ms for the first 6 seconds.
  // Catches B4B's async button-state updates that don't fire as mutation events.
  var pollCount = 0;
  var pollMax = 24; // 6s / 250ms
  var pollTimer = setInterval(function () {
    sweep();
    if (++pollCount >= pollMax) clearInterval(pollTimer);
  }, 250);

  // MutationObserver — watches B4B's grid for any subtree change (new cards OR
  // button-state mutations inside existing cards). Debounced so we don't sweep
  // 100x per second during B4B's initial population.
  var sweepDebounce = null;
  var observer = new MutationObserver(function () {
    clearTimeout(sweepDebounce);
    sweepDebounce = setTimeout(sweep, 80);
  });

  function startObserver() {
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'class'],
      });
    } else {
      setTimeout(startObserver, 50);
    }
  }
  startObserver();
})();
